export const textPkTitleClassName = 'text-paragraph_m text-gray_400';
export const textPkDescriptionClassName = 'text-gray_600 text-paragraph_l';
